module.exports = __webpack_public_path__ + "img/photo_ph.4d311cb5.svg";